export const STATIC_OPTIONS = {
  gzip: true,
  maxage: 365 * 24 * 60 * 60 * 1000,
};

export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const THREE_SECONDS_IN_MILLISECONDS = ONE_SECOND_IN_MILLISECONDS * 3;
export const ONE_MINUTE_IN_MILLISECONDS = ONE_SECOND_IN_MILLISECONDS * 60;
export const TWO_MINUTES_IN_MILLISECONDS = ONE_MINUTE_IN_MILLISECONDS * 2;
export const FIVE_MINUTES_IN_MILLISECONDS = ONE_MINUTE_IN_MILLISECONDS * 5;
export const TEN_MINUTES_IN_MILLISECONDS = ONE_MINUTE_IN_MILLISECONDS * 10;
export const ONE_HOUR_IN_MILLISECONDS = ONE_MINUTE_IN_MILLISECONDS * 60;
export const FIVE_HOUR_IN_MILLISECONDS = ONE_HOUR_IN_MILLISECONDS * 5;
export const TWELVE_HOURS_IN_MILLISECONDS = ONE_HOUR_IN_MILLISECONDS * 12;
export const ONE_DAY_IN_MILLISECONDS = ONE_HOUR_IN_MILLISECONDS * 24;

//export const TEN_MINUTES = 10 * 60 * 1000;
//export const ONE_HOUR = 60 * 1000 * 60;
//export const FOUR_HOUR = 60 * 1000 * 60;
export const ONE_MINUTES_IN_SECONDS = 60;
export const TWO_MINUTES_IN_SECONDS = 2 * 60;
export const FIVE_MINUTES_IN_SECONDS = 5 * 60;
export const FIFTEEN_MINUTES_IN_SECONDS = 15 * 60;
export const TEN_MINUTES_IN_SECONDS = 15 * 60;
export const ONE_HOUR_IN_SECONDS = 60 * 60;
export const TWELVE_HOURS_IN_SECONDS = 12 * 60 * 60;
export const SIX_HOUR_IN_SECONDS = 6 * 60 * 60;
export const FOUR_HOUR_IN_SECONDS = 4 * 60 * 60;

export const ONE_DAY_IN_SECONDS = ONE_HOUR_IN_SECONDS * 24;

export const SOCIALS = {
  TELEGRAM: 'Telegram',
  TWITTER: 'Twitter',
  VK: 'VK',
  WHATSAPP: 'Whatsapp',
  FACEBOOK: 'Facebook',
  VIBER: 'Viber',
  OK: 'OK',
  INSTAGRAM: 'Instagram',
};

export const TRIGGER_WORDS = [
  'Facebook',
  'Фейсбук',
  'Фэйсбук',
  'fb.com',
  'fb.me',
  'FB ',
  ' FB',
  ' FB-',
  'Instagram',
  'instagram.com',
  ' IGTV',
  'IGTV ',
  ' IGTV-',
  'Инстаграм',
  'Meta Platforms',
  ' Meta',
  'Meta ',
  ' Meta-',
  ' Мета',
  'Мета ',
  ' Мета-',
];

export const META_DISCLAIMER =
  'Meta признана экстремистской организацией и запрещена в России, также под запрет попали действия её дочерних проектов Facebook и Instagram.';

export const CREATE_ERROR = {
  default: {
    title: 'Отзыв не отправлен',
    message: 'Произошла неизвестная ошибка, попробуйте позже',
  },
  429: {
    title: 'Отзыв не отправлен',
    message: 'Не спешите! Публиковать отзывы можно не чаще, чем раз в две минуты!',
  },
  409: {
    title: 'Отзыв не отправлен',
    message: 'К сожалению, пока нельзя добавить новый отзыв, попробуйте дополнить предыдущий',
  },
  403: {
    title: 'Отзыв не отправлен',
    message: 'Под этой учётной записью нельзя оставлять отзывы',
  },
};

export const NOTIFICATION_TIMEOUT = THREE_SECONDS_IN_MILLISECONDS;
